import { callApi } from "@src/api/callApi"
import { DEVICE_TYPE } from "@src/devices/types"

export type PATCH_DEVICE_FIELDS = Partial<
  Pick<
    DEVICE_TYPE,
    | "name"
    | "description"
    | "framenumber"
    | "framecolor"
    | "bikeoptions"
    | "brand"
    | "bikemodel"
    | "owner_name"
    | "owner_address"
    | "owner_phone"
  >
>

type PATCH_DEVICE_BODY = {
  device: PATCH_DEVICE_FIELDS
}

type PATCH_DEVICE_RESPONSE = {
  success: boolean
  device: DEVICE_TYPE // TO DO: The backend device response is incomplete
  error?: string
}

export const patchDeviceSerialNumber = (
  partnerUuid: string,
  serialnumber: string,
  device: PATCH_DEVICE_FIELDS,
) =>
  callApi<PATCH_DEVICE_BODY, PATCH_DEVICE_RESPONSE>({
    method: "PATCH",
    path: `/partner/${partnerUuid}/device/${serialnumber}`,
    body: { device },
  })
